import type { FC } from 'react';

import type { IconProps } from './type';

export const RubiesIcon: FC<IconProps> = (props) => {
  return (
    <svg
      fill="none"
      height={13}
      viewBox="0 0 15 12"
      width={15}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.593 4.031 9.382.598h-2.51L5.66 4.03h4.933ZM3.312.598.627 4.03h4.071L5.91.598H3.312ZM15.627 4.03 12.94.598h-2.597l1.211 3.433h4.072Zm-3.847.867-2.748 7.547 6.595-7.547H11.78Zm-3.647 7.7 2.673-7.688H5.423l2.71 7.688Zm-7.494-7.7 6.557 7.512-2.71-7.512H.639Z"
        fill="#B4BAE9"
      />
    </svg>
  );
};
